import "core-js/modules/es.array.map.js";
/**
 * value - value to store in localStorage/backend. Cannot contain commas because that is treated as an array delimiter for our local storage system
 * searchPageValue - value to use in the search page
 */
export var BUDGET_OPTIONS = [{
  label: '~$10K or less',
  value: '10000',
  searchPageKey: 'tuitions',
  searchPageValue: '0:1000,1001:5000,5001:10000'
}, {
  label: '~$10K-$20K',
  value: '20000',
  searchPageKey: 'tuitions',
  searchPageValue: '10001:20000'
}, {
  label: 'More than $20K',
  value: '999999999',
  searchPageKey: 'tuitions',
  searchPageValue: '20001:35000,35001:'
}, {
  label: 'I would like to apply for an education loan',
  // student budget preference backend only accepts positive integer values. this is a hacky solution to allow the user to select this option
  value: '1',
  searchPageKey: 'tags',
  searchPageValue: 'loan_available'
}];
export var VALID_BUDGET_LOCAL_STORAGE_VALUES = BUDGET_OPTIONS.map(function (option) {
  return option.value;
});